import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { G_TABLE_CELL__images_preview } from '../_base/cells/G_TABLE_CELL__images_preview';
import { HOOK_TABLE_LAYOUT__inputs__base } from '../_base/HOOK_TABLE_LAYOUT__inputs__base';

interface PROPS {
  fields: FIELD__list_image_asset[];
}

const helper_column = createColumnHelper<FIELD__list_image_asset>();

export function HOOK_TABLE_LAYOUT__inputs__image_asset_list({ fields }: PROPS) {
  const columns__additional = useMemo(
    () => [
      // Actions
      // helper_column.accessor(field => field, {
      //   id: 'actions',
      //   header: 'actions',
      //   cell: info => (
      //     <G_TABLE_CELL__inputs_images__buttons_base field={info.getValue()}>
      //       <G_GRAPH__BUTTON__list_images_download field={info.getValue()} />
      //       <G_GRAPH__BUTTON__list_images_upload field={info.getValue()} />
      //       <G_GRAPH__BUTTON__list_images_view_in_fullscreen field={info.getValue()} />
      //       <G_GRAPH__BUTTON__list_images_clear field={info.getValue()} />
      //     </G_TABLE_CELL__inputs_images__buttons_base>
      //   ),
      // }),
      // Preview
      helper_column.accessor(row => row.items.map(item => item.asset), {
        id: 'preview',
        header: '',
        cell: info => <G_TABLE_CELL__images_preview image_assets={info.getValue()} />,
      }),
    ],
    [],
  );

  return HOOK_TABLE_LAYOUT__inputs__base({ fields, columns__additional });
}
